import { Routes, Route, Navigate } from 'react-router-dom';
import Landing from '../pages/Landing/Landing';
import Login from '../pages/Login/Login';
import Signup from '../pages/Signup/Signup';
import VerifyEmail from '../pages/VerifyEmail/VerifyEmail';
import ForgotPassword from '../pages/ForgotPassword/ForgotPassword';
import ResetPassword from '../pages/ResetPassword/ResetPassword';
import InviteAccept from '../pages/InviteAccept/InviteAccept';
import SsoStart from '../pages/Sso/SsoStart';
import SsoCallback from '../pages/Sso/SsoCallback';
import AppsThemeBoundary from '../pages/Apps/AppsThemeBoundary';
import PublicAppPage from '../pages/Apps/public/PublicAppPage';

import { IS_OS_URL } from '@constants/index';

const UnauthenticatedRoutes = () => {
  return (
    <Routes>
      {/* Landing page only on OS URLs */}
      {IS_OS_URL && <Route path="/" element={<Landing />} />}

      {/* Organization invitation (works before login) */}
      <Route path="/org/invite/token/:token" element={<InviteAccept />} />
      <Route path="/org/invite" element={<InviteAccept />} />

      <Route
        path="/apps/shared/:token"
        element={
          <AppsThemeBoundary>
            <PublicAppPage />
          </AppsThemeBoundary>
        }
      />

      {/* Auth routes */}
      <Route path="/auth/login" element={<Login />} />
      <Route path="/sso/:provider" element={<SsoStart />} />
      <Route path="/auth/callback" element={<SsoCallback />} />
      <Route path="/auth/signup" element={<Signup />} />
      <Route path="/auth/verify" element={<VerifyEmail />} />
      <Route path="/auth/forgot-password" element={<ForgotPassword />} />
      <Route path="/auth/reset-password" element={<ResetPassword />} />

      {/* Legacy route compatibility */}
      <Route path="/login" element={<Navigate to="/auth/login" replace />} />

      {/* Default redirect */}
      <Route path="*" element={<Navigate to={IS_OS_URL ? '/' : '/auth/login'} replace />} />
    </Routes>
  );
};

export default UnauthenticatedRoutes;
